import { useState } from 'react';

import { makePaymentBill } from '../../../api/ans';
import { closePopup, openPopup } from '../../../store/slices/popupSlice';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { parseRuNumber } from '../../../utils/functions';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function InvoicePopup() {
  const dispatch = useAppDispatch();
  const popupProps = useAppSelector((state) => state.popup.popupProps);
  const displayedPeriod = popupProps?.displayedPeriod || '';
  const monthlyRate = popupProps?.monthlyRate || 0;
  const discount = popupProps?.discount || 0;
  const total = popupProps?.total || 0;
  const services = popupProps?.services || '';
  const user = useAppSelector((state) => state.user.data);
  const isLegalEntity = user.type !== 'individual';
  const [loading, setLoading] = useState(false);

  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  const handleClick = () => {
    setLoading(true);
    makePaymentBill({
      amount: parseRuNumber(total) ? parseRuNumber(total) : total,
      pay_type: services,
    })
      .then((value) => {
        console.log(value);
        window.open(value.filepath);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Ошибка при создании счёта:', error);
        setLoading(false);
        dispatch(openPopup('topUpFail'));
      });
  };

  return (
    <div className={styles.invoicePopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.invoiceTextWrapper}>
        <h2 className={styles.invoiceTitle}>Счёт на оплату</h2>
        <div className={styles.invoiceSummaryBlock}>
          {!isLegalEntity && (
            <p className={styles.invoiceSummaryText}>
              <span>Выбранный период: </span>
              <span className={styles.invoiceSummaryStroke} />
              <span>{displayedPeriod}</span>
            </p>
          )}
          <p className={styles.invoiceSummaryText}>
            <span>Тариф: </span>
            <span className={styles.invoiceSummaryStroke} />
            <span>{monthlyRate} ₽/мес</span>
          </p>
          {!isLegalEntity && (
            <p className={styles.invoiceSummaryText}>
              <span>Скидка: </span>
              <span className={styles.invoiceSummaryStroke} />
              <span>{discount}%</span>
            </p>
          )}
        </div>
        <p
          className={`${styles.invoiceSummaryText} ${styles.invoiceSummaryText_flexend}`}
        >
          Итого к оплате <span className={styles.invoiceTotalText}>{total} ₽</span>
        </p>

        <RedButton
          text="Скачать счёт на оплату"
          onClick={handleClick}
          width={332}
          height={50}
          loading={loading}
        />
      </div>
    </div>
  );
}

export default InvoicePopup;
